export default __webpack_public_path__ + "static/media/menu.f4f02707.svg";